import { provideKeycloak, AutoRefreshTokenService, UserActivityService, withAutoRefreshToken, createInterceptorCondition, IncludeBearerTokenCondition } from 'keycloak-angular';
import { environment } from 'src/environments/environment';

const getKeycloakUrl = (): string => {
  if (environment.production && environment.env === 'prod') {
    return 'https://auth-eur.at-systems.pro/';
  } else if (environment.env === 'local') {
    return 'https://auth-eur.at-systems.pro/';
  }

  return 'https://auth-eur.at-systems.dev/';
};

export const provideKeycloakAngular = () =>
  provideKeycloak({
    config: {
      url: getKeycloakUrl(),
      realm: 'master',
      clientId: 'front',
    }, //TODO: change to config
    initOptions: {
      onLoad: 'login-required',
      // silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
      checkLoginIframe: false,
      silentCheckSsoFallback: false,
      scope: 'offline_access'
    },
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'none',
        sessionTimeout: 60000,
      }),
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
    ],
  });

  export const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /.*/,
    bearerPrefix: 'Bearer'
  });
